const AdminDashboard = () => import('../pages/supplier/dashboard').then((m) => m.default || m)
const Profile = () => import('../pages/supplier/editprofile').then((m) => m.default || m)
const Payouts = () => import('../pages/supplier/payouts').then((m) => m.default || m)
const NotFound = () => import('../pages/errors/404').then((m) => m.default || m)
const SingleProduct = () => import('../pages/admin/SingleProduct').then((m) => m.default || m)

const Orders = () => import('../pages/supplier/orders').then((m) => m.default || m)
const Products = () => import('../pages/supplier/products').then((m) => m.default || m)
const AddProduct = () => import('../pages/supplier/addproduct').then((m) => m.default || m)
const EditProduct = () => import('../pages/supplier/editproduct').then((m) => m.default || m)
const ProductImportOptions = () => import('../pages/supplier/ProductImportOptions').then((m) => m.default || m)
const ReviewProducts = () => import('../pages/supplier/ReviewProductsToImport').then((m) => m.default || m)

export default [
  {
    path: '/',
    name: 'home',
    redirect: {
      path: '/product',
    },
    meta: {
      is_supplier: true,
    },
  },
  {
    path: '/dashboard',
    name: 'adminDashboard',
    component: AdminDashboard,
    meta: {
      is_supplier: true,
    },
  },

  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: {
      is_supplier: true,
    },
  },
  {
    path: '/orders/:userid?/:storeid?',
    name: 'orders',
    component: Orders,
    props: true,
    meta: {
      is_supplier: true,
    },
    reuse: true,
  },
  {
    path: '/payouts',
    name: 'payouts',
    component: Payouts,
  },
  {
    path: '/product',
    name: 'product',
    component: Products,
    meta: {
      is_supplier: true,
    },
  },
  {
    path: '/product/edit/:id',
    name: 'editproduct',
    component: EditProduct,
    meta: {
      is_supplier: true,
    },
  },
  {
    path: '/product/add',
    name: 'addproduct',
    component: AddProduct,
    meta: {
      is_supplier: true,
    },
  },
  {
    path: '*',
    component: NotFound,
    meta: {
      is_supplier: true,
    },
  },
  {
    path: '/product/:id/:slug',
    name: 'single-product',
    component: SingleProduct,
    meta: {
      is_supplier: true,
    },
  },
  {
    path: '/product-import-options',
    name: 'productimportoptions',
    component: ProductImportOptions,
    meta: {
      is_supplier: true,
    },
  },
  {
    path: '/review-products',
    name: 'review-products',
    component: ReviewProducts,
    meta: {
      is_supplier: true,
    },
  },
]
